<template>
	<div class="mTrendsCo">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBoxMdy">
			<img class="mFirst" src="../../assets/newsBd.jpg">
		</div>
		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- <el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>

		<div class="mTrendsCoMain">
			<div class="trendsMainTabs">
				<el-tabs :class="activeName=='first'? 'first-Background':'second-Background'" v-model="activeName"
					type="card" @tab-click="handleClick">
					<el-tab-pane class="elPane2" :class="activeName=='second'? 'first-Background':'second-Background'"
						label="企业新闻" name="second">
						<div class="secondBox" @click="enterMedia(item.id)" v-for="(item,index) in newsData" :key="index">
							<div class="newsItem">
								<div class="dyNewMainBoxItemImg">
									<img class="dyNewImg" :src="item.thumbnail_url" alt="">
								</div>
								<div class="dyNewsContent">
									<div class="dyNewsContentTitle busiz-text-ellipes1">{{item.title}}</div>
								</div>
							</div>
							<div class="lineHeight"></div>
						</div>

						<div class="paginationBox">
								<!-- 分页 -->
								<zpagenav v-bind:page="pageNum" v-bind:page-size="pageSize" v-bind:total="total"
								         v-bind:max-page="maxPage"  v-on:pagehandler="pageHandler">
								</zpagenav>
							</div>

					</el-tab-pane>
					<el-tab-pane :class="activeName=='third'? 'second-Background':'first-Background'" label="视频资讯"
						name="third">
						<div class="thirdBox">
							<div class="videoItem" @click="enterVideo(item.id,item.video_url)"
								v-for="(item,index) in newsData" :key="index">
								<div class="videoImgBox">
									<img class="videImg" :src="item.thumbnail_url" alt="">
								</div>
								<div class="videoTitle">{{item.title}}</div>
								<div class="videoTime">{{item.create_time}}</div>
								<div class="lineHeight2"></div>
							</div>
						</div>
						<div class="paginationBox">
								<!-- 分页 -->
								<zpagenav v-bind:page="pageNum" v-bind:page-size="pageSize" v-bind:total="total"
								         v-bind:max-page="maxPage"  v-on:pagehandler="pageHandler">
								</zpagenav>
							</div>
					</el-tab-pane>

					<el-tab-pane class="elPane2" :class="activeName=='zero'? 'first-Background':'second-Background'"
						label="菩提节 · 风采" name="zero">
						<div class="secondBox" @click="enterMedia(item.id)" v-for="(item,index) in newsData" :key="index">
							<div class="newsItem">
								<div class="dyNewMainBoxItemImg">
									<img class="dyNewImg" :src="item.thumbnail_url" alt="">
								</div>
								<div class="dyNewsContent">
									<div class="dyNewsContentTitle busiz-text-ellipes1">{{item.title}}</div>
								</div>
							</div>
							<div class="lineHeight"></div>
						</div>

						<div class="paginationBox">
								<!-- 分页 -->
								<zpagenav v-bind:page="pageNum" v-bind:page-size="pageSize" v-bind:total="total"
								         v-bind:max-page="maxPage"  v-on:pagehandler="pageHandler">
								</zpagenav>
							</div>

					</el-tab-pane>
				</el-tabs>
			</div>
		</div>

		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
import { myGet, myPost, login } from "../../api/http.js";
export default {
	data() {
		return {

			pageNum: 1,  //显示的是哪一页
			pageSize:9, //每一页显示的数据条数
			total: 10, //记录总数
			maxPage:12,  //最大页数
			
			


			activeName: 'second',
			tableActive: 1,
			newsData: [],
			drawer: false,
			direction: 'ltr'
		}
	},
	created() {
		this.gitSecurity(0)
	},
	methods: {
		handleClick(tab, event) {
			let that = this;
			console.log(tab, event);
			let selId = tab.$el.id;
			if (selId == 'pane-zero') {
				that.tableActive = 0;
				that.pageNum = 1;
				that.gitSecurity(0)
			} else if (selId == 'pane-second') {
				that.tableActive = 1;
				that.pageNum = 1;
				that.gitSecurity(1)
			} else if (selId == 'pane-third') {
				that.tableActive = 2;
				that.pageNum = 1;
				that.gitSecurity(2)
			}
		},
		//获取兰树新闻
		gitSecurity() {
			console.log('111', this.tableActive)
			// 0.兰树新闻 1.媒体聚焦 2.视频咨询
			myPost("api/messageslist/", {
				newtype: this.tableActive,
				pageNum: this.pageNum,
				pageSize: 9
			}).then((res) => {
				this.newsData = res.data.news_list;
				this.total = res.data.total_num;
			});
		},
		enterMedia(id) {
			this.$router.push({ path: '/mNewsDetail', query: { userId: id } });
		},
		enterVideo(opaction, videoUrl) {
			this.$router.push({ path: '/mVideoDetail', query: { userId: opaction, videoUrl: videoUrl } });
		},
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		},

		//pagehandler方法 跳转到page页
		pageHandler: function (page) {
					//here you can do custom state update
				    this.pageNum = page;
					myPost("api/messageslist/", {
						 newtype: this.tableActive,
						 pageNum: page,
						 pageSize: 9
					}).then((res) => {
					   this.newsData = res.data.news_list;
					   this.total = res.data.total_num;
					});
				},
	}
}
</script>

<style scoped>

.paginationBox{
		width: 100%;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
.mTrendsCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirst {
	width: 100%;
}

.mFirstBox {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 99;
}


.mFirstBoxImgBox {
	width: 100%;
	margin-top: 0.5rem;
}

.mFirstBoxImg {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.firstBoxMdy {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 3.5rem;
}



.mTrendsCoMain {
	display: flex;
	flex-direction: column;
	width: 100%;
	background: #FFFFFF;
	padding-bottom: 1rem;
}

.trendsMainTabs {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin: 0 auto;
	position: relative;
	background: #FFFFFF;
}

.secondBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	margin-top: 1rem;
}

.newsItem {
	width: 90%;
	display: flex;
	flex-direction: row;
	margin-top: 1rem;
	margin: 0 auto;
}

.dyNewMainBoxItemImg {
	width: 40%;
	border-radius: 0.5rem;
}



.dyNewImg {
	width: 100%;
	border-radius: 0.5rem;
}


.dyNewsContent {
	width: 50%;
	display: flex;
	flex-direction: column;
	margin-left: 1rem;
}


.dyNewsContentTitle {
	color: #000000;
	font-size: 1rem;
}



.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #333333;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	color: #333333;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	color: #333333;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}

.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;
	color: #333333;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	color: #333333;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	color: #333333;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #333333;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}



.thirdBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	background-color: #FFFFFF;
}

.videoItem {
	width: 100%;
	display: flex;
	flex-direction: column;
	margin-top: 1rem;
	border-radius: 1rem;
	padding-bottom: 1rem;
}

.videoImgBox {
	width: 90%;
	margin: 0 auto;
	margin-top: 0.5rem;
	border-radius: 1rem;
}

.videImg {
	width: 100%;
	border-radius: 1rem;
}

.videoTitle {
	width: 90%;
	color: #000001;
	font-size: 1rem;
	margin: 0 auto;
	margin-top: 0.5rem;
}

.videoTime {
	width: 90%;
	margin: 0 auto;
	color: #999;
	font-size: 0.875rem;
	margin-top: 0.5rem;
}

/* .second-Background{
		background:#FFFFFF;
	}
	
	.first-Background{
		background: #EDEDED;
	} */


.lineHeight {
	width: 100%;
	height: 0.6rem;
	background-color: #F4F5F5;
	margin-top: 0.5rem;
}


.lineHeight2 {
	width: 100%;
	height: 0.6rem;
	background-color: #F4F5F5;
	margin-top: 0.5rem;
}


.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.footerBoxMain {
	width: 100%;
	background-color:  #2c5eff;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}


.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}

/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	align-items: center;
	justify-content: space-between;
	z-index: 999;
}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mLansuTrends.vue